import {
  ExperienceReservationResponse,
  ExperienceReservationState,
} from "redmond";
import { put } from "redux-saga/effects";
import { actions } from "../actions";
import { fetchBookedActivities } from "../../../api/v0/trips/fetchBookedActivities";
import dayjs from "dayjs";

export function* fetchBookedActivitiesSaga() {
  try {
    const experiencesReservationResponse: ExperienceReservationResponse =
      yield fetchBookedActivities({
        states: [
          ExperienceReservationState.Present,
          ExperienceReservationState.Future,
          ExperienceReservationState.Past,
        ],
        referenceDateTime: dayjs().format(),
      });

    const {
      future: newFuture = [],
      past: newPast = [],
      present: newPresent = [],
    } = experiencesReservationResponse.itineraries;

    const bookedActivities: boolean =
      newFuture.length > 0 || newPast.length > 0 || newPresent.length > 0;

    yield put(actions.setUserHasActivitiesBooked(bookedActivities));
  } catch (e) {
    yield put(actions.setUserHasActivitiesBooked(false));
    console.error(e);
  }
}
